import { describeErrorBody } from '~/services/http/utils'
import type { IProblemDetails } from '~/types/errors/models'

// The api answers a refused sign-in with RFC 9457 problem details
// (`{status, type, title, detail}`), and has since its Litestar rewrite
// (2025-07). The login page matched on an `errorCode` field the api no longer
// sends, so a wrong password showed "Unknown type of user authentication error:
// undefined." (seen on staging, 2026-10-05). It went unnoticed because the MSW
// mock kept sending the old shape; the mock now sends the real one
// (api/msw/api/users/authenticate.ts).
export const INVALID_CREDENTIALS_TYPE =
  'user_authentication/invalid_credentials'
export const IDENTITY_DISABLED_TYPE = 'user_authentication/identity_disabled'

export const INVALID_CREDENTIALS_MESSAGE = `The credentials you entered don't match any on file. Please try again.`
export const IDENTITY_DISABLED_MESSAGE =
  'Password sign-in is turned off for this account.' +
  ' Sign in with a passkey, or ask your administrator for help.'

function problemType(body: unknown): string | undefined {
  if (!body || typeof body !== 'object') {
    return undefined
  }
  const type = (body as Partial<IProblemDetails>).type
  return typeof type === 'string' ? type : undefined
}

/** The message the login page shows for a 403 from a sign-in. */
export function describeAuthenticationRefusal(responseBody: unknown): string {
  switch (problemType(responseBody)) {
    case INVALID_CREDENTIALS_TYPE:
      return INVALID_CREDENTIALS_MESSAGE
    case IDENTITY_DISABLED_TYPE:
      return IDENTITY_DISABLED_MESSAGE
    default:
      return describeErrorBody(
        responseBody,
        'There was a problem logging you in. Please try again.'
      )
  }
}
